<template>
  <component
    class="p-4"
    :is="component"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'SurfaceContent',
  mixins: [ defaultRootComponent('div') ]
}

</script>
